import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Eye, Share2, Compass, Users } from 'lucide-react';
import ShareToCommunity from '@/components/ShareToCommunity';

export default function SermonCard({ sermon, user, onUpdate, onNextStep }) {
  const navigate = useNavigate();

  return (
    <div
      data-testid={`sermon-card-${sermon.id}`}
      className="bg-white rounded-2xl shadow-lg border border-pulpit-100 p-6 sermon-card hover:shadow-xl transition-all"
    >
      <div className="flex items-center space-x-2 mb-3">
        <span className="px-2 py-1 bg-pulpit-100 text-pulpit-800 text-xs font-medium rounded-full">
          {sermon.sermon_type}
        </span>
        <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full">
          {sermon.format_type}
        </span>
        {sermon.is_public && (
          <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full flex items-center">
            <Share2 className="w-3 h-3 mr-1" />
            Public
          </span>
        )}
      </div>

      <h3 className="font-display text-xl font-bold text-pulpit-900 mb-2 line-clamp-2">
        {sermon.title}
      </h3>

      {sermon.scripture_reference && (
        <p className="text-sm text-pulpit-700 mb-3 font-medium">
          {sermon.scripture_reference}
        </p>
      )}

      {sermon.topic && (
        <p className="text-sm text-pulpit-700 mb-3 font-medium">
          Topic: {sermon.topic}
        </p>
      )}

      <p className="text-gray-600 text-sm line-clamp-3 mb-4">
        {sermon.content.substring(0, 120)}...
      </p>

      <div className="flex justify-between items-center text-xs text-gray-500 mb-4">
        <span>
          {new Date(sermon.created_at).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })}
        </span>
      </div>

      <div className="flex gap-2">
        <Button
          data-testid={`view-sermon-${sermon.id}-button`}
          onClick={() => navigate(`/sermon/${sermon.id}`)}
          className="flex-1 bg-pulpit-600 hover:bg-pulpit-700 text-white"
        >
          <Eye className="w-4 h-4 mr-2" />
          View
        </Button>
        {user && (
          <ShareToCommunity sermon={sermon} user={user} />
        )}
        {onNextStep && (
          <Button
            onClick={() => onNextStep(sermon)}
            variant="outline"
            className="border-glory-400 text-glory-700 hover:bg-glory-50"
            title="What's Next?"
          >
            <Compass className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
}